<div class="dataset-details">
  <div class="row">
    <div class="col">
      <table class="table table-sm text-sm align-top">
        <tbody>
          <tr>
            <td class="lighter">Created&nbsp;with:</td>
            <td class="width-max">
              {{ toolCategory }} / {{ toolName }}
              <!-- context dropdown -->
              <div ngbDropdown class="d-inline-block">
                <button
                  type="button"
                  class="btn btn-sm ms-1 btn-outline-dark no-caret-dropdown dropdown-menu-button"
                  id="viewDropdownMenuButton"
                  ngbDropdownToggle
                  aria-haspopup="true"
                  aria-expanded="false"
                  title="Actions">
                  <!-- <i class="fa-solid fa-bars" aria-hidden="true"></i> -->
                  <i class="fas fa-lg fa-ellipsis-h" aria-hidden="true"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="viewDropdownMenuButton">
                  <button ngbDropdownItem (click)="selectTool()" [class.disabled]="!tool">Select tool</button>
                  <button ngbDropdownItem (click)="showJob()" [class.disabled]="!sourceJob">Show job</button>
                </div>
              </div>
            </td>
          </tr>
          @if (sourceJob && sourceJob.parameters.length > 0) {
            <tr>
              <td class="lighter">Parameters:</td>
              <td id="parameters-container">
                @if (sourceJob && sourceJob.parameters.length > 0) {
                  <ch-dataset-parameter-list
                    [parameters]="sourceJob.parameters"
                    [parametersLimit]="parametersLimit"
                    [tool]="tool"></ch-dataset-parameter-list>
                }
              </td>
            </tr>
          }

          <tr>
            <td class="lighter">Size:</td>
            <td class="width-max">{{ dataset.size | bytes: 0 }}</td>
          </tr>
          <tr>
            <td class="lighter">Date:</td>
            <td>{{ dataset.created | localDate }}</td>
          </tr>
          <tr>
            <td class="lighter">Labels:</td>
            <td>
              @if (getDatasetLabels(); as labels) {
                @for (label of labels; track label.labelId) {
                  <ch-link-button (click)="editLabels()">
                    <ch-label-pill [label]="label"></ch-label-pill>
                  </ch-link-button>
                }
                @if (labels.length === 0) {
                  <ch-link-button class="no-underline-link-button text-sm" (click)="editLabels()">
                    Add labels
                  </ch-link-button>
                }
              }
            </td>
          </tr>
          <tr>
            <td class="lighter">History:</td>
            <td>
              <ch-link-button class="no-underline-link-button text-sm" (click)="showHistory()">
                Show history
              </ch-link-button>
            </td>
          </tr>
          <tr>
            <td class="lighter">Notes:</td>
            <td>
              <textarea
                #notesArea
                [(ngModel)]="dataset.notes"
                class="dataset-notes"
                rows="6"
                placeholder="{{ notesPlaceholderInactive }} "
                (focus)="editNotes(notesInput)"
                (focusout)="saveNotes(dataset, notesInput)"
                #notesInput></textarea>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
